import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import EditGroup from './../edit/EditGroup';
import DialogBase from './DialogBase';
import { DialogContent, DialogTitle } from '@mui/material';

class DialogEditGroup extends React.Component {

  render () {
    const { classes, open, onClose, group, ...others } = this.props;
    const scrollableTargetId = "dialog-edit-group";
    return (
      <DialogBase
        open={open}
        onClose={onClose}
      >
        <DialogTitle>{ group ? "Modifier un groupe" : "Nouveau groupe" }</DialogTitle>
        <DialogContent classes={{root: classes.dialogContent}} id={scrollableTargetId}>
          <EditGroup
            scrollableTarget={scrollableTargetId}
            group={group}
            {...others}
          />
        </DialogContent>
      </DialogBase>
    )
  }
}

const styles = theme => ({
  dialogContent: {
    padding: theme.spacing(0),
  },
});

DialogEditGroup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogEditGroup);
